import React from "react";
import { useParams } from "react-router-dom";
import { useVendor } from "../../hooks/useVendors";
import { Box, Typography, CircularProgress, Alert, Table, TableHead, TableBody, TableRow, TableCell, Link } from "@mui/material";
import BackButton from "../Shared/BackButton";

export default function CorrectedVendors() {
  const { id } = useParams();
  const { data, isLoading, error } = useVendor(id);
  const vendor = data?.vendor ?? {};
  const correctedVendors = data?.correctedVendors ?? [];

  if (isLoading) {
    return (
      <Box display="flex" justifyContent="center" alignItems="center" minHeight="200px">
        <CircularProgress />
      </Box>
    );
  }

  if (error) {
    return (
      <Box m={4}>
        <Alert severity="error">
          Error loading vendor: {error.message}
        </Alert>
      </Box>
    );
  }

  return (
    <>
      <Box m={4}>
        <Typography variant="h2" gutterBottom sx={{ pt: 2 }}>
          Vendors Corrected to {vendor.vendorName}
        </Typography>
        <BackButton />
      </Box>
      {correctedVendors.length > 0
        ? (
          <Box>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell>Vendor ID</TableCell>
                  <TableCell>Vendor Name</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {correctedVendors.map((correctedVendor) => (
                  <TableRow key={correctedVendor.id}>
                    <TableCell>
                      <Link href={`/vendors/${correctedVendor.id}`}>
                        {correctedVendor.id}
                      </Link>
                    </TableCell>
                    <TableCell>{correctedVendor.vendorName}</TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </Box>
        )
        : (
          <Box m={4}>
            <Alert severity="info">
            No vendors are currently corrected to this vendor.
            </Alert>
          </Box>
        )}
    </>
  );
}
